import { useQuery } from "@tanstack/react-query";
import { useJwt } from "common-frontend-components";
import { type ReactNode, createContext, useMemo } from "react";

import api from "@/api/axiosInstance";

export const StorageContext = createContext({
    url: "",
});

export default function StorageProvider({ children }: { children: ReactNode }) {
    const { userId } = useJwt();

    const authenticated = useMemo(() => {
        return !!userId;
    }, [userId]);

    const { data } = useQuery({
        queryKey: ["StorageUrl"],
        queryFn: async () => (await api.get(`admin/env/storageUrl`)).data.data,
        staleTime: Infinity,
        enabled: authenticated,
    });
    return <StorageContext.Provider value={{ url: data }}>{children}</StorageContext.Provider>;
}
